export class CertificateAccessRequestDto {
  access_request_required: boolean;

  constructor(access_request_required: boolean) {
    this.access_request_required = access_request_required;
  }
}
